import { view } from "@risingstack/react-easy-state";
import { IconClose } from "@tine/designsystem-icons/sharp";
import { Chip } from "@tine/designsystem-ui-react";
import { cn } from "@tine/designsystem-utils";
import type { HTMLAttributes } from "react";
import type { LegalFilterKey } from "../../common/types/productTypes";
import { translateFilterValue } from "../../common/utils/filterUtils";
import productStore from "../../stores/product/productStore";

type FilterInfo = {
   field: LegalFilterKey;
   value: string;
};

type CurrentFiltersProps = HTMLAttributes<HTMLDivElement> & {
   ignoreFields?: LegalFilterKey[];
};
const CurrentFilters = ({ className, ignoreFields = ["brandGroup"], ...props }: CurrentFiltersProps) => {
   const { activeFilters } = productStore;

   const filterNames = Object.keys(activeFilters);

   const filters: FilterInfo[] = filterNames
      .flatMap((field) => activeFilters[field as LegalFilterKey]?.map((value) => ({ field, value }) as FilterInfo))
      .filter((fi) => fi && !ignoreFields.includes(fi.field)) as FilterInfo[];

   const createCloseHandler =
      ({ field, value }: FilterInfo) =>
      () => {
         productStore.removeFilterValue(field, value);
      };

   if (!filters.length) {
      return null;
   }
   return (
      <div {...props} className={cn(className)}>
         <h3 className="tw-text-h5 tw-block">Brukte Filter:</h3>
         <div className="tw-flex tw-gap-2 tw-mb-2 tw-flex-wrap">
            {filters.map(({ field, value }) => (
               <Chip
                  checked
                  icon={<IconClose className="tw-size-[18px]" />}
                  className="tw-text-sm"
                  key={`${field}-${value}`}
                  onClick={createCloseHandler({ field, value })}
               >
                  {translateFilterValue(field, value)}
               </Chip>
            ))}
         </div>
      </div>
   );
};

export default view(CurrentFilters);
